const PRIMARY_API_URL =
  "https://instaport-e6fnbjbhhtbbc7ca.southindia-01.azurewebsites.net";
const BACKUP_API_URL = "https://api.instaportdelivery.in";

// const PRIMARY_API_URL = "http://192.168.1.118:1000";
// const BACKUP_API_URL = "http://192.168.1.118:1000";
const API_STORAGE_KEY = "instaport_master_active_api_url";

let activeApiUrl = PRIMARY_API_URL;

const getWindow = () => (typeof window === "undefined" ? null : window);

const getStoredApiUrl = () => {
  const currentWindow = getWindow();
  if (!currentWindow) return null;

  try {
    const storedUrl = currentWindow.localStorage.getItem(API_STORAGE_KEY);
    return storedUrl === BACKUP_API_URL || storedUrl === PRIMARY_API_URL
      ? storedUrl
      : null;
  } catch (_) {
    return null;
  }
};

const storeActiveApiUrl = (url) => {
  const currentWindow = getWindow();
  if (!currentWindow) return;

  try {
    currentWindow.localStorage.setItem(API_STORAGE_KEY, url);
  } catch (_) {}
};

const checkHealth = async (baseUrl) => {
  const currentWindow = getWindow();
  if (!currentWindow) return false;

  const controller = new AbortController();
  const timeoutId = currentWindow.setTimeout(() => controller.abort(), 3000);

  try {
    const response = await fetch(`${baseUrl}/health`, {
      cache: "no-store",
      signal: controller.signal,
    });
    return response.ok;
  } catch (_) {
    return false;
  } finally {
    currentWindow.clearTimeout(timeoutId);
  }
};

export const initializeApiUrlFallback = async () => {
  const primaryHealthy = await checkHealth(PRIMARY_API_URL);
  if (primaryHealthy) {
    activeApiUrl = PRIMARY_API_URL;
    storeActiveApiUrl(PRIMARY_API_URL);
    return activeApiUrl;
  }

  const backupHealthy = await checkHealth(BACKUP_API_URL);
  if (backupHealthy) {
    activeApiUrl = BACKUP_API_URL;
    storeActiveApiUrl(BACKUP_API_URL);
    // eslint-disable-next-line no-console
    console.warn("Primary API unavailable. Using backup API:", BACKUP_API_URL);
    return activeApiUrl;
  }

  activeApiUrl = PRIMARY_API_URL;
  storeActiveApiUrl(PRIMARY_API_URL);
  return activeApiUrl;
};

activeApiUrl = getStoredApiUrl() || PRIMARY_API_URL;
initializeApiUrlFallback();

export const getApiUrl = () => activeApiUrl;

const API_URL = {
  toString: () => activeApiUrl,
  valueOf: () => activeApiUrl,
  get current() {
    return activeApiUrl;
  },
  primary: PRIMARY_API_URL,
  backup: BACKUP_API_URL,
};

export default API_URL;
